import React from "react"

import { OutboundLink } from 'gatsby-plugin-google-analytics'
import { trackCustomEvent } from 'gatsby-plugin-google-analytics'

import twitterLight from "../../images/social/twitter-light.svg"
import twitterDark from "../../images/social/twitter-dark.svg"
import twitterBlack from "../../images/social/twitter-black.svg"

import styles from "./socialLinks.module.scss"

import { TWITTER_URL } from "../../constants.js"

const images = {
  twitterLight,
  twitterDark,
  twitterBlack,
}

const TwitterLink = ({ variant, share, shareCopy }) => {
  if (share) {
    return (
      <a
        href={`https://twitter.com/intent/tweet?text=${shareCopy}&source=webclient`}
        target="_blank"
        rel="noopener noreferrer"
        onClick={(e) => {
          trackCustomEvent({
            category: "Social",
            action: "Share",
            label: "Twitter",
            value: null
          })

          return true
        }}
      >
        <img
          className={styles.img}
          src={images[`twitter${variant}`]}
          alt="Twitter Logo"
          layout="fixed"
        />
      </a>
    )
  }

  return (
    <OutboundLink href={TWITTER_URL} target="_blank" rel="noopener noreferrer">
      <img
        className={styles.img}
        src={images[`twitter${variant}`]}
        alt="Twitter Logo"
        layout="fixed"
      />
    </OutboundLink>
  )
}

TwitterLink.defaultProps = {
  shareCopy: "I’m getting early access to Till -- the app designed for real families to empower kids with the tools for spending, saving, and investing. Get Till at https://www.tillfinancial.io"
}

export default TwitterLink
